module.exports = __webpack_public_path__ + "img/index-manual-step-3@3x.cf1cbe0d.png";